import platform from 'platform';
import { useEffect } from 'react';
import { appleStoreLink } from '../../../Constants/branchUrls';
import { getScreenName } from '../../../Utils/helper';
import { GetMyloApp } from '../../ArticlePage/IsthisHelpful/styled';
import { InstallNudgeContainer, NudgeTitle } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function InstallNudge({
  installLink,
  appIsPreasent,
  articlePage,
}) {
  useEffect(() => {
    fireEvent({
      category: 'served_strip',
      screen_name: getScreenName(),
      page_url: typeof window != 'undefined' ? window.location.href : 'NA',
      parent: 'Install App Nudge Strip Mobile',
    });
  }, []);

  const ctaClickHandler = () => {
    fireEvent({
      category: 'clicked_strip_cta',
      screen_name: getScreenName(),
      page_url: typeof window != 'undefined' ? window.location.href : 'NA',
      parent: 'Install App Nudge Strip Mobile',
      cta: appIsPreasent ? 'OPEN IN APP' : 'GET APP',
      deeplink_value: installLink,
    });
    let redirectUrl = installLink;
    if (platform?.os?.family?.includes('iOS')) redirectUrl = appleStoreLink;
    window.location.href = redirectUrl;
  };

  return (
    <>
      <InstallNudgeContainer articlePage={articlePage}>
        {/* <Cross onClick={closeInstallStrip}>&#9587;</Cross> */}
        <NudgeTitle>Browse faster in app</NudgeTitle>
        <GetMyloApp qna nudge className="shake_animate">
          <span onClick={ctaClickHandler}>
            <img
              src="/images/moble_icon.svg"
              alt="mob-icon"
              width="18px"
              height="18px"
            />
            {appIsPreasent ? 'OPEN IN APP' : 'GET APP'}
          </span>
        </GetMyloApp>
        {/* {getDeviceType() == "mWeb"  ? (
                    <MobileNotifPopup
                        installLink={installLink}
                        appIsPreasent={appIsPreasent}
                    />
                ) : null} */}
      </InstallNudgeContainer>
    </>
  );
}
